import { Outlet } from 'react-router-dom'
import { ShieldAlert } from 'lucide-react'
import { useAuth } from '@/hooks/use-auth'

export function AdminLayout() {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
      </div>
    )
  }

  const isAdmin = user?.is_global_admin === true

  if (!isAdmin) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/30">
          <ShieldAlert className="h-8 w-8 text-red-600 dark:text-red-400" />
        </div>
        <h2 className="mt-4 font-heading text-xl font-semibold">Access Denied</h2>
        <p className="mt-2 max-w-md text-sm text-muted-foreground">
          You do not have admin privileges to access this area. Contact your
          system administrator if you believe this is an error.
        </p>
      </div>
    )
  }

  return <Outlet />
}
